const headerDataBottom = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "HPName",
		label: "医院",
		columnwidth: 250,
	},
	{
		prop: "TechnicalOffices",
		label: "科室",
		columnwidth: 100,
	},
	{
		prop: "DetailRemark",
		label: "备注",
		columnwidth: 150,
		options: []
	}, {
		prop: "NeedShowOfficeName",
		label: "是否打印科室",
		columnwidth: 100,
	},
	{
		prop: "Doctor",
		label: "术者",
		columnwidth: 100,
	},
	{
		prop: "SurgeryCountPerYear",
		label: "手术量/年",
		columnwidth: 130,
	},
	{
		prop: "HosGradeName",
		label: "等级",
		columnwidth: 150,
	},
];
export default headerDataBottom;


/**, {
		prop: "Dispatcher",
		label: "配送商",
		columnwidth: 150,
	},
	{
		prop: "DispatcherTypeName",
		label: "配送商类型",
		columnwidth: 150,
		options: []
	}*/